    <div class="General">
      <ul>
        <li
          class="action-button users-nav"
          [class.active-users]="activeGeneral === 'users-table'"
          (click)="setActiveGeneral('users-table')"
          (keyup.enter)="setActiveGeneral('users-table')"
          tabindex="0"
          role="button"
        >
          <mat-icon>person</mat-icon>Usuarios
        </li>
        <li
          class="action-button teams-nav"
          [class.active-teams]="activeGeneral === 'teams'"
          (click)="setActiveGeneral('teams')"
          (keyup.enter)="setActiveGeneral('teams')"
          tabindex="0"
          role="button"
        >
          <mat-icon>people</mat-icon>Grupos
        </li>
      </ul>
    </div>